module.exports = __webpack_public_path__ + "img/icon_card015.ff14dc47.png";